import React from 'react';
import styles from './CoreGroup.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import formatStyles from '@/helpers/formatStyles';

let cx = className.bind(styles);

const layoutMapping = {
	orientation: {
		vertical: 'column',
		horizontal: 'row',
	},
	flexWrap: {
		wrap: 'wrap',
		nowrap: 'nowrap',
	},
	justifyContent: {
		left: 'flex-start',
		center: 'center',
		right: 'flex-end',
		stretch: 'stretch',
		'space-between': 'space-between',
	},
	verticalAlignment: {
		top: 'flex-start',
		center: 'center',
		bottom: 'flex-end',
		stretch: 'stretch',
		'space-between': 'space-between',
	},
};

function setLayoutStyles(layoutObj) {
	const tempObj = {};
	if (!layoutObj) return tempObj;
	if (layoutObj?.type === 'flex') {
		tempObj.display = 'flex';
		if (layoutObj.flexWrap) {
			tempObj.flexWrap = layoutMapping.flexWrap[layoutObj.flexWrap];
		}
		if (layoutObj.orientation) {
			tempObj.flexDirection = layoutMapping.orientation[layoutObj.orientation];
		}
		if (layoutObj.justifyContent) {
			if (layoutObj.orientation === 'vertical') {
				tempObj.alignItems = layoutMapping.justifyContent[layoutObj.justifyContent];
			} else {
				tempObj.justifyContent = layoutMapping.justifyContent[layoutObj.justifyContent];
			}
		}
		if (layoutObj.verticalAlignment) {
			if (layoutObj.orientation === 'vertical') {
				tempObj.justifyContent = layoutMapping.verticalAlignment[layoutObj.verticalAlignment];
			} else {
				tempObj.alignItems = layoutMapping.verticalAlignment[layoutObj.verticalAlignment];
			}
		}
	} else if (layoutObj.contentSize) {
		if (layoutObj.contentSize) {
			tempObj.width = layoutObj.contentSize;
			tempObj.maxWidth = '100%';
		}
		if (layoutObj.justifyContent === 'left') {
			tempObj.marginRight = 'auto';
		}
		if (layoutObj.justifyContent === 'right') {
			tempObj.marginLeft = 'auto';
		}
		if (layoutObj.justifyContent === 'center') {
			tempObj.marginLeft = 'auto';
			tempObj.marginRight = 'auto';
		}
	}
	return tempObj;
}

export default function CoreGroup(props) {
	const { attributes, innerBlocks } = props;
	const styles = { ...formatStyles(attributes.style), ...setLayoutStyles(JSON.parse(attributes.layout)) };
	const className = attributes.className?.split(' ') || [];

	function InnerBlocks() {
		return React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] });
	}
	return React.createElement(attributes.tagName, { id: attributes.anchor, className: cx(['ns_group', 'group', attributes.textColor && `text-color-${attributes.textColor}`, ...className, attributes.backgroundColor && `bg-${attributes.backgroundColor}`, attributes.align && `align-${attributes.align}`]), style: styles }, <InnerBlocks />);
}

CoreGroup.fragments = {
	key: `CoreGroupFragment`,
	entry: gql`
		fragment CoreGroupFragment on CoreGroup {
			attributes {
				align
				anchor
				backgroundColor
				className
				tagName
				style
				textColor
				layout
			}
		}
	`,
};

CoreGroup.config = {
	name: 'CoreGroup',
};
CoreGroup.displayName = 'CoreGroup';
